import {htmlTagRegex} from "@/helpers/regex";

export function validateHTML(htmlString) {
  const trimmedHTML = htmlString.trim();
  if (!trimmedHTML) return false;

  const noComments = trimmedHTML.replace(/<!--[\s\S]*?-->/g, '');
  try {
    const forbiddenTagRegex = /<\/?(script|iframe|object|embed|link|meta|style)[^>]*>/gi;
    if (forbiddenTagRegex.test(noComments)) return false;

    const inlineEventHandlerRegex = /\s(on\w+)\s*=\s*(['"]).*?\2/gi;
    if (inlineEventHandlerRegex.test(noComments)) return false;

    const javascriptHrefRegex = /href\s*=\s*['"]\s*javascript:/gi;
    if (javascriptHrefRegex.test(noComments)) return false;

    return htmlTagRegex.test(noComments);
  } catch (e) {
    console.error(e);
  }

}
